import * as React from "react";
import type { SVGProps } from "react";
const SvgPieChart01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 2.4a9.6 9.6 0 0 1 9.6 9.6 9.6 9.6 0 1 1-19.2 0A9.6 9.6 0 0 1 12 2.4m0 0V12m0 0-6.6 6.6M12 12 5.4 5.4"
    />
  </svg>
);
export default SvgPieChart01;
